// https://p-app-receita-federal.estaleiro.serpro.gov.br/servicos-rfb-apprfb-perdcomp/apprfb-perdcomp/
//consulta/ni/45039237000114?dataInicial=2013-06-17&dataFinal=2024-06-13

import { useQuery } from "@tanstack/react-query";
import { HttpClient, ServiceProvider } from "config/httpClient";
import { ProspectionRecord } from "Pages/Prospection/index.types";
import { CNPJ, SearchParams } from "Pages/Search/index.types";
import { stripCnpj } from "Utils";

export type ProspectionSearch = {
  searchParams: SearchParams;
  searchInterval: Number;
};

const doSearch = async ({
  searchParams,
  searchInterval,
}: ProspectionSearch) => {};

export const useGetListProspects = () =>
  useQuery({
    queryKey: ["basicCnpjInfo"],
    queryFn: async (): Promise<ProspectionRecord[]> => {
      const response = await HttpClient(ServiceProvider.NinApi).get<
        ProspectionRecord[]
      >(`prospection`);
      return Promise.resolve(response.data);
    },
    retry: true,
    retryDelay: 3000,
    retryOnMount: false,
  });

export const useGetBasicCnpjInfo = (cnpj: CNPJ, interval: Number = -1) =>
  useQuery({
    queryKey: ["useGetBasicCnpjInfo", cnpj],
    queryFn: async (): Promise<ProspectionRecord> => {
      const response = await HttpClient(
        ServiceProvider.NinApi,
      ).get<ProspectionRecord>(
        `prospection/cnpj/${stripCnpj(cnpj)[0]}/interval/${interval}`,
      );
      return Promise.resolve(response.data);
    },
    enabled: false,
    retry: false,
    retryDelay: 3000,
    retryOnMount: false,
  });

export const useProspectionSearch = (
  { searchParams, searchInterval }: ProspectionSearch,
  enabled: boolean,
) =>
  useQuery({
    queryKey: ["prospection", searchParams, searchInterval],
    queryFn: () => doSearch({ searchParams, searchInterval }),
    enabled,
  });
